module.exports = __webpack_public_path__ + "media/images/posts/wedding-alcko-fed6de8f77bd374fa743aafd861c7ae5.jpg";